import { Dialog } from "@mui/material";
import styled from "styled-components";

export const CustomDialog = styled(Dialog)<{ scale: number }>`
	z-index: 9998;
	.MuiPaper-root {
		transform: scale(${(props) => props?.scale});
		border-radius: 25px;
		padding-bottom: 0.15rem;
		width: 370px;
		min-width: 370px;
		height: 390px;
		min-height: 390px;
	}
`;
